import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'prg-glance',
  templateUrl: './glance.component.html',
  styleUrls: ['./glance.component.less']
})
export class GlanceComponent implements OnInit {

  @Input() value: any;
  @Input() text: string;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/glance/glance.component.ts